import React from "react"
import hoistStatics from "hoist-non-react-statics"

export const withStaticProps = (staticProps) => (WrappedComponent) => {
  const WithStaticProps = (props) => <WrappedComponent {...staticProps} {...props} />

  return hoistStatics(WithStaticProps, WrappedComponent)
}
